import type { OsasCloseUnfinishedExaminationData } from '@common/validation/customControls/osas/osasCloseUnfinishedExaminationSchema';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';

export function OsasCloseUnfinishedExaminationRead(): JSX.Element {
    const { processActivity } = useProcessActivityReadContext<OsasCloseUnfinishedExaminationData>();
    const translate = getSelectedLanguage();
    const { customControlData } = processActivity;

    return (
        <FormParagraphFormGroup label={translate.request.abortProcessConfirmation}>
            {customControlData.reason ? translate.abortProcessReasonsEnum[customControlData.reason] : ''}
        </FormParagraphFormGroup>
    );
}
